<template>
  <div class="phone-input" v-show="show">
    <div class="form-group row" :class="{ 'has-feedback' : isDirty }">
      <label :for="options.name" :class="options.fullWidth ? 'col-sm-12' : 'col-sm-3 col-form-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-9'">
        <input class="form-control" type="text"
          :id="options.name"
          :class="formControlValidationClass"
          @input="validate($event.target.value)"
          :value="value"
          :name="options.name"/>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  validationClass,
  validationMessage,
  formControlValidationClass
} from '@/util/helpers'

export default {
  name: 'PhoneInput',
  props: {
    value: {
      type: String
    },
    options: {
      type: Object,
      default () {
        return {
          value: '',
          required: false
        }
      }
    }
  },
  data () {
    return {
      invalidMessage: 'Phone number entered is not valid',
      isDirty: false,
      isValid: false,
      isLength: false,
      isRegex: false,
      minLength: 1,
      show: true,
      regex: /^[0-9-()+\s]{5,}$/
    }
  },
  mounted () {
    if (this.options.hidden) this.show = false
  },
  computed: {
    validationClass,
    validationMessage,
    formControlValidationClass
  },
  methods: {
    validate (val = this.value) {
      val ? this.$emit('input', val.trim()) : this.$emit('input', val)
      if (val) {
        this.isDirty = true
        this.isLength = this.isValid = val.length > this.minLength
        if (this.isLength) this.isRegex = this.isValid = new RegExp(this.regex, 'gi').test(val)
      } else if (this.options.required) {
        this.isDirty = true
        this.isValid = false
      } else {
        this.isValid = true
        this.isDirty = false
      }
    },
    runWatcher (val, name) {
      if (this.options.watchers.includes(name)) {
        switch (name) {
          case 'hasESMserviceContract':
            if (!val) this.validate('')
            this.show = val
            this.options.required = val
            break
          case 'hasEmbeddedServices':
            if (!val) this.validate('')
            this.show = val
            this.options.required = val
            break
          case 'hasElectricityContract':
            if (!val) this.validate('')
            this.show = val
            this.options.required = val
            break
          case 'hasHotWaterContract':
            if (!val) this.validate('')
            this.show = val
            this.options.required = val
            break
          case 'hasLiftContract':
            if (!val) this.validate('')
            this.show = val
            this.options.required = val
            break
          case 'hasGarageDoorContract':
            if (!val) this.validate('')
            this.show = val
            this.options.required = val
            break
          case 'hasAccessControlContract':
            if (!val) this.validate('')
            this.show = val
            this.options.required = val
            break
          case 'hasAccessDoorContract':
            if (!val) this.validate('')
            this.show = val
            this.options.required = val
            break
          case 'hasVentilationContract':
            if (!val) this.validate('')
            this.show = val
            this.options.required = val
            break
          case 'hasCleaningContract':
            if (!val) this.validate('')
            this.show = val
            this.options.required = val
            break
          case 'hasFacilityManager':
            if (!val) this.validate('')
            this.show = val
            this.options.required = val
            break
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/PhoneInput.vue